import {
  IGetInvitableOnsiteInterviewsApiResponse,
  IGetInvitableOnsiteInterviewsResult,
} from '../types';

const toGetInvitableOnsiteInterviewsResult = (
  response: IGetInvitableOnsiteInterviewsApiResponse,
): IGetInvitableOnsiteInterviewsResult => ({
  data: response.onsiteInterviews.map((it) => ({
    onsiteInterviewId: it.onsiteInterviewId,
    date: it.date,
    dayOfWeek: it.dayOfWeek,
    startTime: it.startTime,
    endTime: it.endTime,
    profession: it.profession,
    subProfession: it.subProfession,
    status: it.status,
    rate: it.rate,
    specialty: it.specialty,
    candidatesAppliedCount: it.candidatesAppliedCount,
    isInvited: it.isInvited,
  })),
});

export const InvitableOnsiteInterviewAdapters = {
  toGetInvitableOnsiteInterviewsResult,
};
